module.exports = __webpack_public_path__ + "img/7.5a305584.jpg";